export default __webpack_public_path__ + "static/media/image-interactive.d6a3949b.jpg";